// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * 
 */
enum SignRequestSource {
    MANUALLY = 'MANUALLY', 
    EXTERNAL = 'EXTERNAL'
};
export default SignRequestSource;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [SignRequestSource.MANUALLY]: {caption: ''},
    [SignRequestSource.EXTERNAL]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
